module.exports = __webpack_public_path__ + "media/images/top-header-bd978be7ffe3fc16028e098c7d297815.jpeg";